module.exports = __webpack_public_path__ + "img/mobile scanner stand-01.20451dce.png";